import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
export const TextPropertyTitle = ({ title }) => {
    return (_jsx(Typography, { variant: 'body2', color: 'text.secondary', fontWeight: 500, noWrap: true, children: title }));
};
TextPropertyTitle.propTypes = {
    title: PropTypes.string.isRequired,
};
export const TextPropertyField = ({ label, primaryText }) => (_jsxs(_Fragment, { children: [_jsx(TextPropertyTitle, { title: label }), _jsx(Tooltip, { title: primaryText, children: _jsx(Typography, { variant: 'body1', fontWeight: 500, mt: 0.5, noWrap: true, children: primaryText }) })] }));
TextPropertyField.propTypes = {
    label: PropTypes.string.isRequired,
    primaryText: PropTypes.string.isRequired,
};
export const SkeletonTextPropertyField = ({ label }) => (_jsxs(_Fragment, { children: [_jsx(TextPropertyTitle, { title: label }), _jsx(Skeleton, { variant: 'body1' })] }));
SkeletonTextPropertyField.propTypes = {
    label: PropTypes.string.isRequired,
};
